import { authOptions } from "../../utils/constants/auth.constant";

export const getAuthMethods = (lang) => authOptions[lang];
